// ImportEmployeeModal.js
import React, { useRef } from "react";
import "./changeStatusModal.css"; // External CSS file
import cancelIcon from "../../../../assets/images/cancelArrow.svg";
import { Form, Formik } from "formik";
import { notifySuccess } from "../../../../assets/elements/Toast";
import * as Yup from "yup";
import CustomErrorMessage from "../../../../assets/common/CustomeErrorMessage";

export default function ChangeStatusModal({ isOpen, onClose }) {
  const fileInputRef = useRef(null);

  function handleOpenFileInput() {
    fileInputRef.current.click();
  }

  const validationSchema = Yup.object({
    reason: Yup.mixed().required("Reason is required"),
  });

  function handleSubmit() {
    notifySuccess("Status Changed Successfully");
    onClose();
  }

  if (!isOpen) return null;

  return (
    <div className="status-modal-overlay" onClick={onClose}>
      <Formik
        initialValues={{
          reason: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
        }) => (
          <Form
            onClick={(e) => e.stopPropagation()}
            className="status-modal-content"
          >
            <div className="status-modal-header">
              <span className="status-modal-title">Reason</span>
              <div className="status-modal-icon-container" onClick={onClose}>
                <img src={cancelIcon} alt="cancel icon" />
              </div>
            </div>
            <label htmlFor="reason" className="status-desc">
              Tell us the reason for you to change the status from Active to
              inactive.
            </label>
            <textarea
              name="reason"
              id="reason"
              value={values.reason}
              onChange={(e) => setFieldValue("reason", e.target.value)}
              className="status-input"
              placeholder="The reason to change the status is....."
            />
            <div className="padding-helper">
              <CustomErrorMessage
                name="reason"
                errors={errors}
                touched={touched}
              />
            </div>
            <div className="status-footer">
              <button
                type="text"
                className="status-footer-cancel-btn"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="status-footer-submit-btn">
                Change Status
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
